<div class="box-mini col" style="width: 280px;">
    <div class="box-mini__content line-bottom">
        <div class="box-mini__content-poliza">
            <p><strong>Nº de póliza</strong></p>
            <p class="cyan" id="numeroPoliza"><strong>{{poliza.numero}}</strong></p>
        </div>
        <div class="box-mini__content-poliza">
            <p><strong>Producto</strong></p>
            <p class="cyan" id="producto"><strong>{{poliza.producto}}</strong></p>
        </div>
    </div>
    <div class="box-mini__content">
        <div class="box-mini__content-valores">
            <p>Valor mensual:</p>
            <p>Valor x KM:</p>
        </div>
        <div class="box-mini__content-valores">
            <p class="cyan" id="valorMensual">{{facturacion.valorFijoTotalMensual | currency:"CLP":"$":'':'es_CL' }}</p>
            <p class="cyan" id="valorSxkm">{{facturacion.valorxKM | currency:"CLP":"$":'':'es_CL' }}</p>
        </div>
        <div class="box-mini__content-valores">
            <p>Inicio vigencia:</p>
            <p>Término vigencia:</p>
        </div>
        <div class="box-mini__content-valores">
            <p class="cyan" id="fechaInicioVigencia">{{poliza.fechaInicio}}</p>
            <p class="cyan" id="fechaFinVigencia">{{poliza.fechaFin}}</p>
        </div>
    </div>
    <div class="box-mini__btn"><a [ngClass]="{'isDisabled': !poliza.downloadAvaliable}" class="button button-secondary button-small" [href]="poliza.urlPoliza" target="_blank" (click)='logPolicyDownload()'>DESCARGAR PÓLIZA</a></div>
</div>
